import { ContentItem } from '..';

export class ImageContentItem extends ContentItem {
  private _imageUrl: string = '';
  imageString: string = '';

  constructor(json: { url?: string }) {
    super();
    this._type = 'image';
    if (json.url) this.imageUrl = json.url;
  }

  get imageUrl() { return this._imageUrl; }

  set imageUrl(url: string) {
    this._imageUrl = url;
    this.updateImageString();
  }

  updateImageString() {
    let splitImageUrl = this.imageUrl.split('%2F');
    if (splitImageUrl.length && splitImageUrl[2]) {
      this.imageString = splitImageUrl[2].replace(/\+/g, ' ');
    }
  }

  copy() {
    return new ImageContentItem(this.toJson());
  }

  toJson() {
    return {
      content_type: 'image',
      url: this.imageUrl
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/content-items/image-content-item.model.ts